import * as React from 'react';

export interface ToastDescription {
  content: string;
  error?: boolean;
  duration?: number;
}

export interface Toast {
  show(options: ToastDescription): void;
}

export const ToastContext = React.createContext<Toast>({
  show() {},
});

export interface WitToastProps {
  toast: Toast;
}

export function withToast() {
  return function addToast<InnerProps>(
    Component: React.ComponentType<InnerProps & WitToastProps>,
  ) {
    return function WithToast(props: InnerProps) {
      return (
        <ToastContext.Consumer>
          {(toast) => <Component {...props} toast={toast} />}
        </ToastContext.Consumer>
      );
    };
  };
}
